import { humanize } from '../humanize';

export function channelTypeLabel(channelType?: string) {
  if (channelType === 'employee_referrals') {
    return 'Referrals';
  }

  return humanize(channelType);
}
